import { Stack, Typography, useTheme } from "@mui/material";
import dayjs from "dayjs";
import React from "react";
import useResponsive from "../../../hooks/useResponsive";

interface WorkExperienceProps {
  jobTitle: string | null;
  company: string | null;
  location: string | null;
  start: Date | null;
  end: Date | null;
}

/**
 * This component displays the work experience of an applicant.
 * @param jobTitle The job title of the applicant.
 * @param company The company the applicant worked for.
 * @param location The location of the company.
 * @param start The start date of the work experience.
 * @param end The end date of the work experience.
 * @returns The work experience of the applicant.
 */
const WorkExperience = ({ jobTitle, company, location, start, end }: WorkExperienceProps) => {
  const theme = useTheme();
  const isMobile = useResponsive("down", "sm");

  if (!jobTitle) {
    return <Typography>Keine Angaben</Typography>;
  }

  return (
    <Stack spacing={1}>
      <Stack spacing={1} direction={isMobile ? "column" : "row"} justifyContent={"space-between"}>
        <Stack>
          <Typography fontWeight={"bold"} color={theme.palette.info.main}>
            Tätigkeit
          </Typography>
          <Typography>{jobTitle}</Typography>
        </Stack>
        <Stack>
          <Typography fontWeight={"bold"} color={theme.palette.info.main}>
            Unternehmen
          </Typography>
          <Typography>{company}</Typography>
        </Stack>
      </Stack>
      <Stack>
        <Typography fontWeight={"bold"} color={theme.palette.info.main}>
          Ort
        </Typography>
        <Typography>{location}</Typography>
      </Stack>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Stack>
          <Typography fontWeight={"bold"} color={theme.palette.info.main}>
            Start
          </Typography>
          <Typography>{dayjs(start).format("DD.MM.YYYY")}</Typography>
        </Stack>
        <Stack>
          <Typography fontWeight={"bold"} color={theme.palette.info.main}>
            Ende
          </Typography>
          <Typography>{dayjs(end).format("DD.MM.YYYY")}</Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default WorkExperience;
